import type { U3204DefaultPromptRef } from '../U3204Service';

export function u3204PickLocalizedDefaultPrompt(
  item: Pick<U3204DefaultPromptRef, 'labelFr' | 'labelEn' | 'promptFr' | 'promptEn'>,
  language: string,
): { label: string; promptText: string } {
  const isEn = language.toLowerCase().startsWith('en');
  return {
    label: isEn ? item.labelEn : item.labelFr,
    promptText: isEn ? item.promptEn : item.promptFr,
  };
}
